<script lang="ts">
  import Heading from "@shared/svelte/Components/Heading.svelte";
  import LayoutStore from "@shared/svelte/Stores/LayoutStore";
  import Sponsored from "@shared/svelte/Components/ProductLines/Sponsored.svelte";
  import TrackedLink from "@shared/svelte/Components/Tracking/TrackedLink.svelte";

  export let carouselName: string;
  export let forwardLink: string = "";
  export let sponsoredFlag: boolean = false;
  export let extraHeaderClasses: string = "";
  export let shortenNameOnMobile: boolean = false;

  $: mobileMode = $LayoutStore.isMobile;
</script>

<style>
  /* These styles need to be left in here to be shared with SCH pages, please do not remove to a separate file */
  .carousel-header {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-end;
    gap: 0.5rem;
    white-space: nowrap;
  }

  .carousel-header-content {
    display: flex;
    gap: 0.5rem;
  }

  .carousel-header-copy {
    display: grid;
    gap: 0.5rem;
    flex-shrink: 1;
  }

  @media (min-width: 1024px) {
    .carousel-header {
      align-items: center;
    }
  }
</style>

<header class={`card-carousel-header fizz-space-between ${extraHeaderClasses}`}>
  <div class="fizz-flex-row">
    <Heading tag="h3" class={`${mobileMode && shortenNameOnMobile ? ` fizz-truncate` : ``}`}>
      {carouselName}
    </Heading>
    {#if sponsoredFlag}
      <Sponsored />
    {/if}
  </div>
  {#if forwardLink}
    <TrackedLink {forwardLink} targetObjectType={"carousel_link"} linkText={"View All"} />
  {/if}
</header>
